import { useId } from 'react'
import { cn } from '@/lib/utils'

/**
 * The Kagami mark. Same tile and sparkle as the Hirax mark (one family across
 * the platform) with a K in place of the H: its upper arm stops short for the
 * sparkle, the way the H's right stem does. The tile runs from the Hirax
 * violet into Kagami's pink and follows the current theme.
 */
export function KagamiMark({ className }: { className?: string }) {
  const id = useId()
  return (
    <svg viewBox="0 0 1024 1024" className={className} aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={id} x1="0.08" y1="0.08" x2="0.92" y2="0.92">
          <stop offset="0" stopColor="hsl(var(--brand-1))" />
          <stop offset="1" stopColor="hsl(var(--kagami))" />
        </linearGradient>
      </defs>
      <rect x="72" y="72" width="880" height="880" rx="230" fill={`url(#${id})`} />
      <path fill="#fff" d="M300 260h120v504H300Z" />
      <path fill="#fff" d="M420 410 540 290 615 365 420 560Z" />
      <path fill="#fff" d="M420 452 724 764H574L420 604Z" />
      <path fill="#fff" d="M700 156Q718 222 784 240Q718 258 700 324Q682 258 616 240Q682 222 700 156Z" />
    </svg>
  )
}

export function Logo({ className, markOnly = false }: { className?: string; markOnly?: boolean }) {
  return (
    <span className={cn('group/logo flex items-center gap-2.5', className)}>
      <span className="relative flex size-8 items-center justify-center">
        <span
          aria-hidden
          className="absolute inset-0 rounded-lg bg-kagami opacity-0 blur-md transition-opacity duration-300 group-hover/logo:opacity-50"
        />
        <KagamiMark className="relative size-8" />
      </span>
      {!markOnly && (
        <span className="flex items-baseline gap-1.5 font-display text-lg font-semibold tracking-tight">
          <span className="text-gradient">Kagami</span>
        </span>
      )}
    </span>
  )
}
